import useCancelOrder from '@activities/order/CancelOrderModal/hooks/useCancelOrder';
import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

interface Params {
    orderNo: string;
}

const CancelOrderModal: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { orderNo } = params;
  const { pop } = useFlow();
  const cancelOrder = useCancelOrder(orderNo);
  return (
      <Modal>
          <ModalContainer>
              <Column align='center' fullWidth spacing={28}>
                  <Column fullWidth align='center' spacing={8}>
                      <Text size='2xl' fontWeight='bold'>주문취소</Text>
                      <Text size='lg'>주문을 취소하시겠습니까?</Text>
                  </Column>
                  <Column spacing={8} fullWidth>
                      <Button fullWidth variant='secondary'
                              onClick={cancelOrder}>
                          주문 취소
                      </Button>
                      <Button fullWidth onClick={pop}>취소</Button>
                  </Column>
              </Column>
          </ModalContainer>
      </Modal>
  );
};

export default CancelOrderModal;
